import SsgFallback from '@components/SsgFallback'
import {getOrderIdFromTrackUrl} from '@helpers/middleware/sharedPages/track'
import websiteSSRTranslations from '@helpers/misc/websiteSSRTranslations'
import getWebsiteIdFromHostname from '@helpers/websites/getWebsiteIdFromHostname'
import useSharedPageRewriteHelper from '@hooks/useSharedPageRewriteHelper'
import AbstractLayout from '@page-components/Layout/AbstractLayout'
import Clean from '@page-components/Layout/Clean'
import dynamic from 'next/dynamic'

const TrackV2 = dynamic(() => import('@page-components/TrackV2'))

export default function TrackV2Page() {
  const router = useSharedPageRewriteHelper('orderId', getOrderIdFromTrackUrl)

  if (router.isFallback) {
    return <SsgFallback />
  }
  return (
    <div className="font-sans">
      <AbstractLayout  LayoutComponent={Clean} darkTheme="darkv2">
        <TrackV2 />
      </AbstractLayout>
    </div>
  )
}

export const getStaticProps = async context => {
  const {websiteId} = await getWebsiteIdFromHostname(context.params.hostname)

  const translationProps = await websiteSSRTranslations(context.params.hostname, ['tracking', 'generic', 'website'])

  return {
    props: {
      ...translationProps,
      websiteId,
      lastRevalidatedAt: new Date().toISOString()
    },
    revalidate: 60 * 60 * 24 * 30
  }
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: true
  }
}
